(function () {
  'use strict';
  class TagIgnoreCtrl {
    constructor($translate, moment, MeasurementUnitConverterService, Authenticator, FeaturehubJsSdk) {
      this.translate = $translate;
      this.moment = moment;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.featureFlagLAINT42 = FeaturehubJsSdk.isFeatureEnabled('LAINT42_tag_ignore');
      this.name = '';
      this.date = '';
      this.dateTimeFormat = '';
      Authenticator.getUser().then((user) => {
        this.dateTimeFormat = `${this.measurementUnitConverterService.getDateFormat(user.measurementUnits.dateTimeFormat).toUpperCase()} HH:mm:ss`;
        this.handleInitValues();
      });
    }

    handleInitValues() {
      if (this.alert) {
        this.name = this.alert.labelInfo.labeledByName;
        this.date = this.alert.labelInfo.labeledAt;
      } else if (this.event) {
        this.name = this.event.labeledByName;
        this.date = this.event.datetimeCreated;
      }
    }

    handleTooltipMessage() {
      this.handleInitValues();
      return this.translate.instant('ce.enum.eventosTooltips.tagIgnoreAlert', {
        name: this.name,
        date: this.moment(this.date).format(this.dateTimeFormat)
      });
    }
  }

  angular
    .module('TagIgnoreModule', [])
    .controller('TagIgnoreCtrl', TagIgnoreCtrl)
    .component('tagIgnore', {
      templateUrl: 'directives/tag-ignore/tag-ignore.tpl.html',
      controller: TagIgnoreCtrl,
      bindings: {
        alert: '<',
        event: '<',
        size: '@',
        position: '@'
      }
    });
}());
